import { React, useState, useEffect } from "react";
import { Modal, Box } from "@mui/material";

import PatientsList from "./PatientsList";
import { opcoesListaPacientes } from "../../utils/labels";

const styles = {
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "1207px",
    maxHeight: "560px",
    width: "80%",
    height: "90%",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 1,
  },
};

const colunasConsultasDoDia = [
  { field: "id", headerName: "ID", width: 5, sortable: false },
  {
    field: "nome",
    headerName: "Nome",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "dataOuHorario",
    headerName: "Última consulta",
    width: 180,
  },
  {
    field: "cpf",
    headerName: "CPF",
    flex: 1,
    maxWidth: 170,
    minWidth: 120,
    sortable: false,
  },
  {
    field: "statusDescricao",
    headerName: "Status",
    flex: 1,
    maxWidth: 170,
    minWidth: 140,
    sortable: false,
  },
  {
    field: "telefone",
    headerName: "Telefone",
    flex: 1,
    maxWidth: 170,
    minWidth: 140,
    sortable: false,
  },
];

export default function ModalPatients({
  openModal,
  setOpenModal,
  descricao,
  actionOptions,
  dados,
  tipoListagem = null,
}) {
  const handleClose = () => {
    setOpenModal();
  };

  const colunasPorTipoListagem = () => {
    if (tipoListagem === opcoesListaPacientes.CONSULTAS_DO_DIA) {
      return colunasConsultasDoDia;
    }

    return [];
  };

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styles.modal}>
        <Box>
          <PatientsList
            isModal={true}
            textModal={descricao}
            setOpenModal={handleClose}
            actionOptions={actionOptions}
            openModal={openModal}
            dados={dados}
            dataColumns={colunasPorTipoListagem()}
          />
        </Box>
      </Box>
    </Modal>
  );
}
